import { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as serviceWorker from "../services/serviceWorkerRegistration";

const ServiceWorkerContext = createContext();

export const ServiceWorkerProvider = (props) => {
    const [assetsUpdateReady, setAssetsUpdateReady] = useState(false);
    const [assetsCached, setAssetsCached] = useState(false);

    const value = useMemo(
        () => ({
            assetsUpdateReady,
            assetsCached,
            // Call when the user confirm update of application and reload page
            updateAssets: () => {
                window.location.reload();
            },
        }),
        [assetsUpdateReady, assetsCached]
    );

    // Once on component mounted subscribe to Update and Succes events in
    // CRA's service worker wrapper
    useEffect(() => {
        serviceWorker.register({
            onUpdate: (registration) => {
                const waitingServiceWorker = registration.waiting;

                if (waitingServiceWorker) {
                    waitingServiceWorker.addEventListener("statechange", (event) => {
                        if (event.target.state === "activated") {
                            setAssetsCached(true);
                        }
                    });

                    waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });
                }

                setAssetsUpdateReady(true);
            },
            onSuccess: () => {
                setAssetsCached(true);
            },
        });
    }, []);

    return <ServiceWorkerContext.Provider value={value} {...props} />;
}

export const useServiceWorker = () => {
    const context = useContext(ServiceWorkerContext);

    if (!context) {
        throw new Error("useServiceWorker must be used within a ServiceWorkerProvider");
    }

    return context;
}
